const encodeAsJsonUriParams = (params) => {
    return encodeURIComponent(JSON.stringify(params));
};

const decodeAsJsonUriParams = (params) => {
    return JSON.parse(decodeURIComponent(params));
};

export {
    encodeAsJsonUriParams,
    decodeAsJsonUriParams
}